export class ProductFilterPrototyp {
  public search_value:string
  public categories:string
  public sort_ascending:boolean
  public sort_categorie:string

  constructor(search_value:string = '', categories:string = 'name', sort_ascending:boolean = false, sort_categorie:string = 'name'){
    this.search_value = search_value;
    this.categories = categories;
    this.sort_ascending = sort_ascending;
    this.sort_categorie = sort_categorie;
  }
}



// WEBPACK FOOTER //
// ./src/assets/shared/product-filter.object.ts